import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/LocalidadesEBM`

export function buscarLocalidadesEnEBM(provincia) {
  return http.get(`${API_ENDPOINT}/BuscarLocalidadesEnEBM/${provincia}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las localidades.',
      tipoError: 'localidad'
    }
  })
}

export function buscarLocalidadesPorIdProvincia(idProvincia) {
  return http.get(`${API_ENDPOINT}/BuscarLocalidadesPorIdProvincia/${idProvincia}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las localidades.',
      tipoError: 'localidad'
    }
  })
}
